const PUBLIC_DISMISS_APPROVAL_PATHS = [
	'/mgm/monitor/approval',
	'/spe-v2/dismiss-decision',
	'/spe-v2/dismiss-approval',
];

const normalizePath = (path) => String(path || '').replace(/\/+$/, '') || '/';

export const isPublicDismissApprovalLocation = (route) => {
	const path = normalizePath(route && route.path);
	const name = route && route.name;
	const hash = String(typeof window !== 'undefined' ? window.location.hash : '');
	const href = String(typeof window !== 'undefined' ? window.location.href : '');

	if (name === 'SpeV2MonitorApproval' || name === 'SpeV2DismissDecision' || name === 'SpeV2DismissApproval') {
		return true;
	}

	if (PUBLIC_DISMISS_APPROVAL_PATHS.includes(path)) {
		return true;
	}

	return PUBLIC_DISMISS_APPROVAL_PATHS.some((candidate) => hash.includes(candidate) || href.includes(candidate));
};
